import { render } from "./PointDesReglements.vue?vue&type=template&id=0ae94306&ts=true"
import script from "./PointDesReglements.vue?vue&type=script&lang=ts"
export * from "./PointDesReglements.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__